import React from 'react'
import { Error404 } from '../../../Library/LoaderPage';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { Card } from 'react-bootstrap';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);


export function CPDPSemester({ data }) {
    if (Object.values(data).length === 0) return <Error404 />;
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'top',
            },
        },
        scales: {
            y: {
                beginAtZero: true,
                title: {
                    display: true,
                    text: 'Points'
                }
            },
            x: {
                title: {
                    display: true,
                    text: 'Semester'
                }
            }
        }
    };

    const labels = data.map(item => `Semester ${item.semester}`);

    const chartData = {
        labels,
        datasets: [
            {
                label: 'CPDP Points',
                data: data.map(item => item.points),
                backgroundColor: 'rgba(54, 162, 235, 1)',
                borderColor: 'rgba(54, 162, 235, 1)',
                borderWidth: 1,
            },
        ],
    };
    return (
        <Card>
            <Card.Body className='px-3 py-3'>
                <h3 className='mb-5'>CPDP Points by Semester</h3>
                <div className="w-100">
                    <Bar options={options} data={chartData} height={200} />
                </div>
            </Card.Body>
        </Card>
    )
}
